var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75663 19.0785C7.26989 18.5988 6.81031 18.1671 6.3738 17.7128C4.92025 16.1997 3.61072 14.5731 2.54196 12.7623C1.79026 11.4889 1.19373 10.1518 0.881141 8.6953C0.162556 5.35021 1.8204 2.05722 4.93328 0.672151C8.37623 -0.859913 12.5091 0.697084 14.0966 4.11697C14.9109 5.87082 14.9243 7.66152 14.4111 9.49501C14.3065 9.86863 14.1577 10.0286 13.7524 10.0826C11.7563 10.3476 10.0746 11.9042 9.59459 13.8768C9.35271 14.8712 9.39848 15.8518 9.74047 16.8171C9.77172 16.9056 9.8041 16.9801 9.71739 17.0682C9.071 17.7251 8.43019 18.3867 7.75663 19.0785ZM11.2346 7.10853C11.2346 5.17456 9.67497 3.61236 7.74473 3.61199C5.81374 3.61199 4.24707 5.17345 4.24409 7.10146C4.24111 9.04175 5.80778 10.6088 7.74659 10.6047C9.68465 10.6006 11.2349 9.04696 11.2346 7.10853Z",
    fill: "url(#paint0_linear_0_5201)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71797 19.0785C8.20472 18.5988 8.6643 18.1671 9.10081 17.7128C10.5544 16.1997 11.8639 14.5731 12.9326 12.7623C13.6844 11.4889 14.2809 10.1518 14.5935 8.6953C15.3121 5.35021 13.6542 2.05722 10.5413 0.672151C7.09838 -0.859913 2.96549 0.697084 1.37798 4.11697C0.563757 5.87082 0.550359 7.66152 1.06353 9.49501C1.1681 9.86863 1.31695 10.0286 1.7222 10.0826C3.71831 10.3476 5.39997 11.9042 5.88002 13.8768C6.1219 14.8712 6.07613 15.8518 5.73414 16.8171C5.70288 16.9056 5.67051 16.9801 5.75722 17.0682C6.40361 17.7251 7.04442 18.3867 7.71797 19.0785ZM4.24004 7.10853C4.24004 5.17456 5.79964 3.61236 7.72988 3.61199C9.66087 3.61199 11.2275 5.17345 11.2305 7.10146C11.2335 9.04175 9.66682 10.6088 7.72802 10.6047C5.78996 10.6006 4.23967 9.04696 4.24004 7.10853Z",
    fill: "url(#paint1_linear_0_5201)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_5201",
    x1: -4.98688,
    y1: 5.83587,
    x2: 28.8221,
    y2: 18.6864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_5201",
    x1: 15.7016,
    y1: 2.77573,
    x2: 0.327197,
    y2: 16.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00754A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.307f7ab0f1fa3bcbd83f25a37ed9b2e5.svg";
export { ForwardRef as ReactComponent };